import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { notificationInterface } from './types';
import AppConstants from '../../helpers/constants/app';

const initialState: notificationInterface = {
	notifications: [],
}

export const notificationSlice = createSlice({
	name: 'notification',
	initialState,
	reducers: {
		addNotification: {
			reducer: (state, action) => {
				// Don't add notifications with empty messages (like suppressed 401 errors)
				if (!action.payload.message || action.payload.message.trim().length === 0) {
					return;
				}
				
				// Suppress success notifications if configured
				if (action.payload.type === 'success' && AppConstants.notifications.suppressSuccessNotifications) {
					return;
				}
				
				// Suppress info notifications if configured
				if (action.payload.type === 'info' && AppConstants.notifications.suppressInfoNotifications) {
					return;
				}
				
				// Always show error notifications (cannot be suppressed)
				
				// Clean the message to remove exception details and stack traces
				let cleanMessage = action.payload.message;
				if (typeof cleanMessage === 'string') {
					// Extract message before " at " which indicates start of stack trace
					const mainMessage = cleanMessage.split(' at ')[0];
					// Remove the exception type prefix (e.g., "Belteq.bMark.Extensions.ApiException: ")
					const messageWithoutException = mainMessage.replace(/^[^:]+:\s*/, '');
					if (messageWithoutException.trim()) {
						cleanMessage = messageWithoutException.trim();
					}
				}
				
				const notif = {
					id: action.payload.id,
					type: action.payload.type,
					message: cleanMessage,
					duration: action.payload.duration || 7000, // Default 7 seconds
					persistent: action.payload.persistent || false, // Default auto-remove
				};
				state.notifications.push(notif);
			},
			prepare: (payload: any) => {
				const id = uuidv4();
				return {
					payload: {
						...payload,
						id,
					},
					meta: undefined,
					error: undefined,
				};
			},
		},
		removeNotification: (state, action) => {
			state.notifications = state.notifications.filter((notif) => notif.id !== action.payload.id);
		},
	},
});

export const { addNotification, removeNotification } = notificationSlice.actions;

export default notificationSlice.reducer;